var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGhost = function SvgIconGhost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.625 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2a9.25 9.25 0 0 0-9.25 9.25v9a1 1 0 0 0 1.634.774l2.114-1.732 2.123 1.733a1 1 0 0 0 1.266-.001L12 19.293l2.113 1.73a1 1 0 0 0 1.266.002l2.123-1.733 2.114 1.732a1 1 0 0 0 1.634-.774v-9A9.25 9.25 0 0 0 12 2M6.873 6.123A7.25 7.25 0 0 1 19.25 11.25v6.888l-1.113-.912a1 1 0 0 0-1.266 0l-2.123 1.732-2.114-1.732a1 1 0 0 0-1.268 0l-2.114 1.732-2.123-1.733a1 1 0 0 0-1.266.001l-1.113.912V11.25a7.25 7.25 0 0 1 2.123-5.127",
    clipRule: "evenodd"
  }))));
};
export default SvgIconGhost;